module.exports = __webpack_public_path__ + "media/images/Featured-mobile-849e86f19d75ca0cb6793e6060cd5e2c.webp";